import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import { useFormattingContext } from '../../../../FormattingProvider/FormattingContext'
import EditAccountButton from '../../../../VisualBalanceSheetV2/EditAccountButton'
import { useVisualBlocksContext } from '../VisualBlocksContext'

function SplitListItem ({ item }) {
  const { formatter } = useFormattingContext()
  const { formats, styles, classNames, enableManualAccountManagement } =
    useVisualBlocksContext()
  const formatString = formats?.listItems ?? 'money'
  const itemStyles = styles?.listItems || {}
  const itemClassNames = classNames?.listItems ?? ''

  return (
    <div
      className={clsx(
        'flex flex-1 gap-1 relative items-center font-size-xs py-2',
        itemClassNames
      )}
      style={{ ...itemStyles }}
    >
      {enableManualAccountManagement && item.accountId && (
        <>
          <EditAccountButton accountId={item.accountId} />
        </>
      )}
      <div className='flex-1'>{item.label}</div>
      <div>{formatter(item.value, formatString)}</div>
    </div>
  )
}

SplitListItem.propTypes = {
  item: PropTypes.object.isRequired
}

export default SplitListItem
